import axios from 'axios';
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


import { API } from './api';
import { Accounts } from './accounts'
import { Navigation } from './navigation';
import { SystemStatus } from './system-status';

let store = new Vuex.Store({
  modules: {
    apiStore: API,
    accountStore: Accounts,
    navigationStore: Navigation,
    systemStatus: SystemStatus,
  }
})


axios.interceptors.request.use((config) => {
  if (config && config.request && config.request.url && !config.request.url.includes('gold')) {
    // store.commit('setAppLoading');
    // console.log('intercepting', config); // eslint-disable-line
  }
  return config;
}, (error) => {
  console.log('Error', error); // eslint-disable-line
  return Promise.reject(error);
});

axios.interceptors.response.use((config) => {
  // console.log('intercepting 2'); // eslint-disable-line
  // store.commit('unsetAppLoading');
  store.commit('unsetAppLoading');
  return config;
}, (error) => {
  // console.log('Error 2', error); // eslint-disable-line
  store.commit('unsetAppLoading');
  return Promise.reject(error);
});


export {
  store
}